// src/pages/ResetPassword.js – NextScenes Reset Password
// Build: 2025-12-25-01

import React, { useMemo, useState } from "react";
import "../App.css";
import { api } from "../api";

function getTokenFromUrl() {
  try {
    const qs = new URLSearchParams(window.location.search);
    return String(qs.get("token") || "").trim();
  } catch {
    return "";
  }
}

export default function ResetPassword({ onNavigate, onNavigatePage }) {
  const nav =
    typeof onNavigate === "function"
      ? onNavigate
      : typeof onNavigatePage === "function"
        ? onNavigatePage
        : null;

  const token = useMemo(() => getTokenFromUrl(), []);

  const [pw1, setPw1] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const canSubmit = useMemo(() => {
    if (busy) return false;
    if (!token) return false;
    if (!pw1 || pw1.length < 8) return false;
    if (pw1 !== pw2) return false;
    return true;
  }, [busy, token, pw1, pw2]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!canSubmit) return;

    setErr("");
    setMsg("");
    setBusy(true);

    try {
      await api.post("/api/auth/reset-password", { token, password: pw1 });
      setMsg("Password changed successfully. Please log in.");
      setPw1("");
      setPw2("");

      setTimeout(() => {
        if (nav) nav("login");
      }, 900);
    } catch (ex) {
      setErr(
        String(
          ex?.data?.message ||
            ex?.response?.data?.message ||
            ex?.message ||
            "Reset failed."
        )
      );
    } finally {
      setBusy(false);
    }
  }

  function goHome() {
    if (nav) nav("home");
  }

  return (
    <div className="page">
      <div className="card" style={{ maxWidth: 520, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
          <h2 style={{ marginTop: 0, marginBottom: 0 }}>Reset Password</h2>

          <button
            className="linkBtn"
            type="button"
            onClick={goHome}
            disabled={busy}
            style={{ fontWeight: 800 }}
            title="Close"
          >
            Close
          </button>
        </div>

        {!token ? (
          <div className="banner" style={{ marginTop: 12 }}>
            Missing reset token. Please use the reset link generated by “Forgot Password”.
          </div>
        ) : null}

        {err ? (
          <div className="banner" style={{ marginTop: 12 }}>
            {err}
          </div>
        ) : null}

        {msg ? (
          <div className="banner" style={{ marginTop: 12 }}>
            {msg}
          </div>
        ) : null}

        <form onSubmit={handleSubmit} style={{ marginTop: 12 }}>
          <label className="label">New Password</label>
          <input
            className="input"
            type="password"
            value={pw1}
            onChange={(e) => setPw1(e.target.value)}
            placeholder="At least 8 characters"
            autoComplete="new-password"
            disabled={busy || !token}
          />

          <label className="label" style={{ marginTop: 10 }}>
            Confirm New Password
          </label>
          <input
            className="input"
            type="password"
            value={pw2}
            onChange={(e) => setPw2(e.target.value)}
            placeholder="Repeat the password"
            autoComplete="new-password"
            disabled={busy || !token}
          />

          <div style={{ marginTop: 14, display: "flex", gap: 10, flexWrap: "wrap" }}>
            <button className="btn" type="submit" disabled={!canSubmit}>
              {busy ? "Saving..." : "Change Password"}
            </button>

            <button
              className="linkBtn"
              type="button"
              onClick={() => nav && nav("login")}
              disabled={busy}
              style={{ fontWeight: 800 }}
            >
              Back to Login
            </button>
          </div>

          <div style={{ marginTop: 10, color: "#475569", fontSize: 13 }}>
            If your link has expired, request a new reset link from the login page.
          </div>
        </form>
      </div>
    </div>
  );
}
